import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Validation() {
  const navigate = useNavigate();

  // State for header data
  const [headerData, setHeaderData] = useState({
    despatchSlNo: '',
    permanentSlNo: '',
    companyName: ''
  });

  // Fetch header data from localStorage when component mounts
  useEffect(() => {
    const fetchHeaderData = () => {
      try {
        // Get form data from localStorage (stored by balanceSheet page)
        const balanceSheetData = localStorage.getItem('balanceSheetFormData');

        if (balanceSheetData) {
          const parsedData = JSON.parse(balanceSheetData);

          setHeaderData({
            despatchSlNo: parsedData.dslNo || '',
            permanentSlNo: parsedData.pslNo || '',
            companyName: parsedData.nameUnit || ''
          });
        } else {
          // If no data in localStorage, set defaults
          console.log('No balanceSheet data found in localStorage');
          setHeaderData({
            despatchSlNo: 'DSL No. not set',
            permanentSlNo: 'PSL No. not set',
            companyName: 'Company name not set'
          });
        }
      } catch (error) {
        console.error('Error fetching data from localStorage:', error);
        setHeaderData({
          despatchSlNo: 'Error loading data',
          permanentSlNo: 'Error loading data',
          companyName: 'Error loading data'
        });
      }
    };

    fetchHeaderData();
  }, []);

  const handleCancel = () => {
    navigate('/asiScheduleMainMenu');
  };

  return (
    <>
      <style>
        {`
          .validation-container {
            min-height: 300px;
            display: flex;
            justify-content: center;
            align-items: flex-start;
          }
          .button-section {
            width: 100%;
            max-width: 800px;
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
            gap: 20px;
            padding: 20px;
            align-content: start;
          }
          .validation-button {
            width: 100%;
            padding: 16px 20px;
            margin-bottom: 16px;
            border: 2px solid #e3f2fd;
            border-radius: 12px;
            font-size: 15px;
            font-weight: 600;
            text-align: left;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            cursor: pointer;
            background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
            color: #495057;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
            position: relative;
            overflow: hidden;
          }
          .validation-button::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
            transition: left 0.5s;
          }
          .validation-button:hover::before {
            left: 100%;
          }
          .validation-button:hover {
            background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
            color: #ffffff;
            border-color: #1976d2;
            transform: translateY(-3px);
            box-shadow: 0 8px 25px rgba(25, 118, 210, 0.3);
          }
          .validation-button:active {
            transform: translateY(-1px);
            box-shadow: 0 4px 15px rgba(25, 118, 210, 0.2);
          }
          .validation-button i {
            margin-right: 12px;
            font-size: 16px;
            width: 20px;
            text-align: center;
          }
          .section-title {
            font-size: 24px;
            font-weight: 700;
            color: #1976d2;
            margin-bottom: 30px;
            padding-bottom: 15px;
            border-bottom: 3px solid #e3f2fd;
            position: relative;
            grid-column: 1 / -1;
          }
          .section-title::after {
            content: '';
            position: absolute;
            bottom: -3px;
            left: 50%;
            transform: translateX(-50%);
            width: 80px;
            height: 3px;
            background: linear-gradient(90deg, #1976d2, #42a5f5);
            border-radius: 2px;
          }
          .card {
            border: none;
            border-radius: 16px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
            overflow: hidden;
          }
          .card-body {
            padding: 30px;
          }
        
          .btn_orange:hover {
            background: linear-gradient(135deg, #e55a2b 0%, #e6851a 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(255, 107, 53, 0.4);
            color: white;
          }
          .btn_orange:active {
            transform: translateY(0);
            box-shadow: 0 2px 10px rgba(255, 107, 53, 0.3);
          }
          .btn_orange:disabled {
            background: linear-gradient(135deg, #adb5bd 0%, #6c757d 100%);
            box-shadow: none;
            transform: none;
            cursor: not-allowed;
          }
        `}
      </style>
      <div className="container-fluid py-3">
        {/* Header Section - Direct Display */}
        <div className="card mb-3">
          <div className="card-body">
            <div className="row align-items-center">
              <div className="col-md-12 mb-3">  
                <h4 className="page_heading mb-3 pb-2 border-bottom">
                  ASI Schedule 2024-25 <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>CONFIDENTIAL <i className="fa fa-lock me-2" style={{ fontSize: '20px', color: '#1976d2' }}></i></span>
                </h4>
                <h5 className="mb-0 pb-3 border-bottom"><span style={{ color: '#1976d2', fontWeight: 'bold' }}>Validation</span> </h5>
              </div>
              <div className="col-md-6">
                <div className="row g-3">
                  <div className="col-md-4">
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '6px' }}>
                      <strong>DSL No.:</strong>
                    </div>
                    <div style={{ fontSize: '14px', color: '#333' }}>
                      {headerData.despatchSlNo}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '6px' }}>
                      <strong>PSL No.:</strong>
                    </div>
                    <div style={{ fontSize: '14px', color: '#333' }}>
                      {headerData.permanentSlNo}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '6px' }}>
                      <strong>Name of Company:</strong>
                    </div>
                    <div style={{ fontSize: '14px', color: '#333' }}>
                      {headerData.companyName}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        

        {/* Table Styles */}
        <style>
          {`
            .table th {
              background-color: #f8f9fa;
              border: 1px solid #dee2e6;
              font-weight: 600;
              font-size: 14px;
              text-align: center;
              vertical-align: middle;
              padding: 8px 4px;
            }
            .table td {
              border: 1px solid #dee2e6;
              padding: 6px 4px;
              font-size: 13px;
            }
            .table input {
              border: 1px solid #e0e0e0;
              background: white;
              width: 100%;
              text-align: center;
              font-size: 13px;
              border-radius: 6px;
              padding: 8px 12px;
              transition: all 0.3s ease;
            }
            .table input:focus {
              outline: none;
              border-color: #f75226;
              transform: translateY(-1px);
            }
            .table input:disabled {
              background-color: #f8f9fa;
              border-color: #dee2e6;
              color: #6c757d;
              cursor: not-allowed;
            }
            .table select {
              border: 1px solid #e0e0e0;
              background: white;
              width: 100%;
              text-align: center;
              font-size: 13px;
              border-radius: 6px;
              padding: 8px 12px;
              transition: all 0.3s ease;
              padding-right: 35px;
            }
            .table select:focus {
              outline: none;
              border-color: #f75226;
              transform: translateY(-1px);
            }
            .status-field {
              background-color: #f8f9fa;
              border: 1px solid #dee2e6;
              padding: 6px 8px;
              font-size: 12px;
              text-align: center;
              min-width: 120px;
            }
          `}
        </style>

        {/* Main Content Area */}

        <div className="card mb-3">
          <div className="card-body">
            <div className="validation-container">
              {/* Centered Validation Buttons */}
              <div className="button-section">
             
                <button 
                  type="button" 
                  className="validation-button"
                  onClick={() => navigate('/fixed-assets-data')}
                >
                  <i className="fa fa-building"></i>
                  Check Fixed Assets Data
                </button>
                <button 
                  type="button" 
                  className="validation-button"
                  onClick={() => navigate('/balance-sheet-data-check')}
                >
                  <i className="fa-solid fa-balance-scale"></i>
                  Check Balance Sheet Data
                </button>
                <button 
                  type="button" 
                  className="validation-button"
                  onClick={() => navigate('/check-pl-account')}
                >
                  <i className="fa-solid fa-chart-line"></i>
                  Check PL Account Data
                </button>
                <button 
                  type="button" 
                  className="validation-button"
                  onClick={() => navigate('/check-pl-account-sorted')}
                >
                  <i className="fa-solid fa-sort"></i>
                  Check PL Account Data (Sorted)
                </button>
                <button 
                  type="button" 
                  className="validation-button"
                  onClick={() => navigate('/net-profit-tally')}
                >
                  <i className="fa-solid fa-calculator"></i>
                  Net Profit Tally
                </button>
                <button 
                  type="button" 
                  className="validation-button"
                  onClick={() => navigate('/error-list')}
                >
                  <i className="fa-solid fa-triangle-exclamation"></i>
                  Error List
                </button>
                {/* <button 
                  type="button" 
                  className="validation-button"
                  onClick={() => navigate('/reports')}
                >
                  <i className="fa fa-file-text"></i>
                  Reports
                </button> */}
              </div>
            </div>
          </div>
        </div>


          <div className="row">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
           
          </div>
        </div>
      </div>
    </>
  );
}

export default Validation; 